module.exports = __webpack_public_path__ + "static/EM3-c391a94c3efb1fa6c427fdf43607b0ab.png";